import { findAbsolutePosition  } from '../../services/reactFlowService';
import { internalSystem } from "../../config/common";


export const doesSameDelegateExist = (name, clusterlets, delegateID) => {

    let status = true;
    
    status = clusterlets.find(clusterlet => {
        return clusterlet.name == name && clusterlet.type == 1 && clusterlet.id !== delegateID;
    });



    return status == null ? true : false;
}

/**Create Delegate object from scratch */
export const createDelegate = (name,description, type, network, direction, delegates, yPosition) => {
    const delegatePosition = findDelegatePosition({direction, delegates, yPosition})

    return {
        name: name,
        type: 1,
        attributes: {
            desc: description,
            type: type,
            network: network
        },
        position: delegatePosition
    }
}


const findDelegatePosition = (payload) => {

    const  { direction, delegates, yPosition } = payload

    const leftBorder = internalSystem.position.x;
    const rightBorder = internalSystem.position.x + internalSystem.style.width;

    const delegateAbsolutePositions = delegates.filter(item => item.name !== 'Controller').map(item => findAbsolutePosition(item.position, 'external_function'))
    let requiredDelegatePositions = [];
    let xPos = 0;

    if(direction === 'right'){
       
        requiredDelegatePositions = delegateAbsolutePositions.filter(item => item.x > leftBorder)
        xPos = rightBorder - 60;  // 60 - delegate half width

    }else{
        
        requiredDelegatePositions = delegateAbsolutePositions.filter(item => item.x < leftBorder)
        xPos = leftBorder - 60;   // 60 - delegate half width

    }


    const yPositions = requiredDelegatePositions?.map(item => item.y)   
    const highestYVal = yPositions.length > 0 ? Math.max(...yPositions) : undefined;

    // console.log("--------------------", {direction ,leftBorder, delegateAbsolutePositions, requiredDelegatePositions, yPositions, highestYVal })

    return {
        x : xPos,
        y: highestYVal && highestYVal !== 0 ? highestYVal + 80 : yPosition
    }

}